import { EventEmitter, inject, Injectable } from '@angular/core';
import { Confirmation, ConfirmationService } from 'primeng/api';
import { defer, map, merge, Observable, take } from 'rxjs';

export const ConfirmationConfig: Confirmation = {
  header: "Confirmar",
  dismissableMask: true,
  icon: "pi pi-info-circle",
  acceptButtonStyleClass: "p-button-text p-button-text",
  rejectButtonStyleClass: "p-button-danger p-button-text",
  closable: true,
  rejectVisible: true,
  acceptVisible: true,
  acceptLabel: "Si",
  rejectLabel: "No",
};

export const isConfirmed = (decision: boolean): decision is true => decision;

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService {
  private readonly confirmationService = inject(ConfirmationService);

  public confirm(prompt: Confirmation): Observable<boolean> {
    return defer(() => {
      const accepted = new EventEmitter<void>();
      const rejected = new EventEmitter();

      this.confirmationService.confirm({
        ...ConfirmationConfig,
        header: prompt.header,
        message: prompt.message,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: prompt.acceptLabel ?? 'Confirmar',
        rejectLabel: prompt.rejectLabel ?? 'Cancelar',
        defaultFocus: 'reject',
        acceptEvent: accepted,
        rejectEvent: rejected,
      });

      return merge(
        accepted.pipe(map(() => true)),
        rejected.pipe(map(() => false)),
      ).pipe(take(1));
    });
  }
}
